// VITE_BACKEND_BASE_URL already includes the /api/v1 base path, so endpoint
// paths must be relative to it (matching screeningEndpoints / eddEndpoints).
const compositeVerdictEndpoints = {
  verdict: (businessKey: string) => `/screen/${businessKey}/composite-verdict`,
  audit: (businessKey: string) => `/screen/${businessKey}/composite-verdict/audit`,
};

export default compositeVerdictEndpoints;
